import React from 'react'
import { connect } from 'react-redux'
import { IntlProvider } from 'react-intl'
import moment from 'moment'
import { onError } from 'lib/intl'

function ReactIntlProvider(props) {
  const { defaultLang, lang, messages, children } = props
  moment.locale(lang)

  return (
    <IntlProvider
      locale={lang}
      defaultLocale={defaultLang}
      messages={messages}
      onError={onError}>
      {children}
    </IntlProvider>
  )
}

const enhance = connect(state => ({
  defaultLang: state.getIn(['locale', 'defaultLang']),
  lang: state.getIn(['locale', 'lang']),
  messages: state.getIn(['locale', 'messages']),
}))

export default enhance(ReactIntlProvider)
